import { Mass, Measure, pounds } from 'safe-units';

export const longTons: Mass = Measure.of(2240, pounds);
